"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_ATTACHMENT_NAME = exports.DEFAULT_UPLOADING_TEXT = exports.SIZE_ERROR_TEXT = exports.FORMAT_ERROR_TEXT = void 0;
var FORMAT_ERROR_TEXT = 'El formato de archivo es inválido';
exports.FORMAT_ERROR_TEXT = FORMAT_ERROR_TEXT;
var SIZE_ERROR_TEXT = 'El archivo excede el tamaño máximo de ';
exports.SIZE_ERROR_TEXT = SIZE_ERROR_TEXT;
var DEFAULT_UPLOADING_TEXT = 'Cargando';
exports.DEFAULT_UPLOADING_TEXT = DEFAULT_UPLOADING_TEXT;
var DEFAULT_ATTACHMENT_NAME = 'Adjunto';
exports.DEFAULT_ATTACHMENT_NAME = DEFAULT_ATTACHMENT_NAME;